import React from 'react';
import { IconlistFeatureModel } from '../../../../fetch-data/graphql';
import { MarkdownContent } from '../../../../fetch-data/graphql';
import { Column, Row } from '../ContentFeature/styles';
import { renderMarkdown } from '../ContentFeature/overrides/markdown';
import { extractFirstImg } from './helpers';
import { IconListImage } from './IconListImage';
import { DividerBox } from '../../../Box/styles';
import { IconListItemContainer, IconWrapper, ContentWrapper } from './styles';

interface IconListFeatureProps {
  feature: IconlistFeatureModel;
}

export const IconListFeature = ({ feature }: IconListFeatureProps) => {
  const { items, splitAtNumber } = feature;

  const splitAtIndex =
    splitAtNumber && splitAtNumber > 0 ? splitAtNumber - 1 : -1;

  // If splitAtIndex is -1, don't split - put everything in the first column
  const leftColumnItems =
    splitAtIndex === -1 ? items : items.slice(0, splitAtIndex);
  const rightColumnItems = splitAtIndex === -1 ? [] : items.slice(splitAtIndex);

  return (
    <Row $gap='80px' style={{ margin: '44px 0px' }}>
      <Column>
        {leftColumnItems.map((item, i) => (
          <IconListFeatureItem
            key={`icon-list-feature-item-${feature._id}-${i}`}
            item={item}
            isFirstItem={i === 0}
          />
        ))}
      </Column>
      {rightColumnItems.length > 0 && (
        <Column>
          {rightColumnItems.map((item, i) => (
            <IconListFeatureItem
              key={`icon-list-feature-item-${feature._id}-${i + splitAtIndex}`}
              item={item}
              isFirstItem={i === 0}
            />
          ))}
        </Column>
      )}
    </Row>
  );
};

interface IconListFeatureItemProps {
  item: MarkdownContent;
  isFirstItem: boolean;
}

export const IconListFeatureItem = ({
  item,
  isFirstItem,
}: IconListFeatureItemProps) => {
  const { imgProps, remainingHtml } = extractFirstImg(item.html || '');

  if (imgProps) {
    return (
      <>
        {isFirstItem && <DividerBox />}
        <IconListItemContainer $isFirstItem={isFirstItem}>
          <IconWrapper>
            <IconListImage
              src={imgProps.src}
              width={imgProps.width}
              height={imgProps.height}
              alt={imgProps.alt}
              data-content={imgProps['data-content']}
            />
          </IconWrapper>
          <ContentWrapper>
            {renderMarkdown({ text: remainingHtml, isPreview: true })}
          </ContentWrapper>
        </IconListItemContainer>
        <DividerBox />
      </>
    );
  }

  return (
    <>
      {isFirstItem && <DividerBox />}
      <IconListItemContainer $isFirstItem={isFirstItem}>
        <ContentWrapper>
          {renderMarkdown({ text: item.html!, isPreview: true })}
        </ContentWrapper>
      </IconListItemContainer>
      <DividerBox />
    </>
  );
};
